import { Response } from "react-select-async-paginate";
import AsyncPaginateBootstrap from "../react-select-bootstrap/AsyncPaginateBootstrap";
import { getList } from "../../api/generics";
import { useSelector } from "react-redux";
import { RootState } from "../../store";
import AccountingAccount from "../../models/accounting-accounts";

const RECORS_PER_SEARCH = 20;

type AccountingAccountSelectProps = {
  value: AccountingAccount | null;
  disabled?: boolean;
  onChange: (_: AccountingAccount | null) => void;
};

const SingleAccountingAccountSelect: React.FC<AccountingAccountSelectProps> = ({
  value,
  disabled,
  onChange,
}) => {
  const companyId = useSelector(
    (state: RootState) => state.company.data.company.id
  );
  const loadOptions = async (
    s: string,
    currentOpts: readonly (
      | AccountingAccount
      | { options: AccountingAccount[]; label?: string }
    )[]
  ): Promise<
    Response<
      AccountingAccount,
      { options: AccountingAccount[]; label?: string },
      any
    >
  > => {
    let additionalParams: Map<string, string> | undefined = new Map<
      string,
      string
    >();

    additionalParams.set("company_id", companyId!.toString());

    if (s !== "") {
      additionalParams.set("search", s);
    }

    const dataPaginated = await getList<AccountingAccount>(
      "/accounting_accounts/",
      RECORS_PER_SEARCH,
      currentOpts.length,
      additionalParams
    );

    let newOpts: AccountingAccount[] = [];
    let count = 0;

    if (dataPaginated.data !== undefined) {
      newOpts = dataPaginated.data.items;
      count = dataPaginated.data.count;
    }

    const hasMore = currentOpts.length + newOpts.length < count;

    return {
      options: newOpts,
      hasMore: hasMore,
    };
  };
  return (
    <AsyncPaginateBootstrap
      placeholder={"Cuenta Contable..."}
      onChange={onChange}
      isMulti={false}
      debounceTimeout={300}
      loadOptions={loadOptions}
      getOptionLabel={(option: AccountingAccount) =>
        `${option.codeIdentifier}-${option.name}`
      }
      getOptionValue={(option: AccountingAccount) => `${option.id}`}
      value={value}
      isDisabled={disabled}
      isClearable
    />
  );
};

export default SingleAccountingAccountSelect;
